import type { FC } from "react";
import { useState } from "react";
import { Stack } from "@mui/material";
import AsyncLoadingButton from "../../../components/asyncLoadingButton/AsyncLoadingButton";
import OptionNameSelect from "./OptionNameSelect";

interface Props {
  onAdd: (value: string) => Promise<void>;
}

const NewOption: FC<Props> = ({ onAdd }) => {
  const [newOptionName, setNewOptionName] = useState("");

  const handleAddNewOption = async () => {
    if (newOptionName.length > 0) {
      await onAdd(newOptionName);
      setNewOptionName("");
    }
  };

  return (
    <Stack direction="row" spacing={1}>
      <OptionNameSelect value={newOptionName} label="Nowa opcja" size="small" onChange={setNewOptionName} />
      <AsyncLoadingButton onClick={handleAddNewOption} disabled={!newOptionName}>
        Dodaj
      </AsyncLoadingButton>
    </Stack>
  );
};

export default NewOption;
